
import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import listService from 'ListService'
import nameTemplate from 'report/properties/main/chart-sort.ejs';


class MainChartSortView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #sortType, #sortOrder' :'updateAttributes'
        };


        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    loadFromColumns() {
        const columns = this.model.get('Columns');
        let group = {sortOrder : 'group', sortType: 'none'}
        if (columns) {
            const gSort = columns.Column[0].Properties.sortOrder;
            const gType = columns.Column[0].Properties.sortType;

            const vSort = columns.Column[1].Properties.sortOrder;
            const vType = columns.Column[1].Properties.sortType;


            if (gSort > 0) {
                group.sortOrder = 'group';
                group.sortType = gType;
            }

            if (vSort > 0) {
                group.sortOrder = 'value';
                group.sortType = vType;
            }
        }
        return group;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const sortOn = $('#sortOrder option:selected').val();
        const sortOrderVal = $('#sortType option:selected').val();

        let aggregate = 'group';
        let sort = 'none';
        let sortOrder = '0';

        let colid = "0";

        if (sortOn === 'group') {
            if (sortOrderVal !== 'none') {
                sort = sortOrderVal;
                sortOrder = '1';
            }
            this.updateColumnProperty(colid, 'sortOrder', sortOrder);
            this.updateColumnProperty(colid, 'sortType', sort);
            this.updateReportingMetaDataColumn(colid, 'sortOrder', sortOrder);
            this.updateReportingMetaDataColumn(colid, 'sortType', sort);

            colid = "1";
            sortOrder = '0';
            sort = 'none';
            this.updateColumnProperty(colid, 'sortOrder', sortOrder);
            this.updateColumnProperty(colid, 'sortType', sort);
            this.updateReportingMetaDataColumn(colid, 'sortOrder', sortOrder);
            this.updateReportingMetaDataColumn(colid, 'sortType', sort);

        }
        if (sortOn === 'value') {
            colid = "1";
            if (sortOrderVal !== 'none') {
                sort = sortOrderVal;
                sortOrder = '1';
            }
            this.updateColumnProperty(colid, 'sortOrder', sortOrder);
            this.updateColumnProperty(colid, 'sortType', sort);
            this.updateReportingMetaDataColumn(colid, 'sortOrder', sortOrder);
            this.updateReportingMetaDataColumn(colid, 'sortType', sort);

            colid = "0";
            sortOrder = '0';
            sort = 'none';
            this.updateColumnProperty(colid, 'sortOrder', sortOrder);
            this.updateColumnProperty(colid, 'sortType', sort);
            this.updateReportingMetaDataColumn(colid, 'sortOrder', sortOrder);
            this.updateReportingMetaDataColumn(colid, 'sortType', sort);
        }



        this.model.set( propName, propVal );
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');

        columns.Column[rowid].Properties[propName] = propVal;
    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        const group = this.loadFromColumns();

        $('#sortOrder').find('option[value='
            + group.sortOrder
            +']').attr('selected', true);

        $('#sortType').find('option[value='
            + group.sortType
            +']').attr('selected', true);

        this.delegateEvents();
        return this;
    }

}

export default MainChartSortView;
